import React from 'react';
import { connect } from 'react-redux';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';

import AppendDocument from './AppendDocument/AppendDocument';
import ArchiveLocation from './ArchiveLocation/ArchiveLocation';
import { ContractType } from './ContractType/ContractType';
import { CycleTimeTracker } from './CycleTimeTracker/CycleTimeTracker';
import { DataFieldsMapping } from './DataFieldsMapping/DataFieldsMapping';
import IntakeFormLink from './IntakeFormLink/IntakeFormLink';
import Notifications from './Notifications/Notifications';
import Permissions from './Permissions/Permissions';
import TicketNamingConventions from './TicketNamingConventions/TicketNamingConventions';

function Settings({ workflow }) {
  const isTicketNamingEnabled = useFlag(FlagType.TicketNaming);
  const isContractTypeEnabled = useFlag(FlagType.WorkflowContractType);
  const isWSSDesignated = workflow.wssDesignated;
  const isMultiDocWorkflowEnabled = useFlag(
    FlagType.MultiDocWorkflowSupportAppendDocumentToContract,
  );
  return (
    <FlexLayout flexDirection="column" space={10}>
      {isTicketNamingEnabled && <TicketNamingConventions />}
      <ArchiveLocation />
      <CycleTimeTracker />
      <DataFieldsMapping />
      <Notifications />
      {isMultiDocWorkflowEnabled && <AppendDocument />}
      <Permissions />
      {!isWSSDesignated && (
        <IntakeFormLink intakeFormLinkId={workflow.permanentLinkId} />
      )}
      {isContractTypeEnabled && isWSSDesignated && <ContractType />}
    </FlexLayout>
  );
}

const mapStateToProps = ({ workflow }) => ({ workflow });

export default connect(mapStateToProps)(Settings);
